module.exports = __webpack_public_path__ + "static/FFB-fecc4f893b36550f3ac809b0fdebe017.jpg";